import { LayoutPageSectionShell } from 'components/authorable/layout/LayoutPageSection/LayoutPageSection';
import { IsNmdpConnectSite } from 'lib/util/site-configuration';
import { useState } from 'react';
import { classnames } from 'tailwindcss-classnames';
import ArrowRight from './SvgArrowRight/arrow-right';
import { menuLocation, pageNavigationDataLayerPush } from 'lib/util/gtm-datalayer';

interface BreadcrumbItem {
  Name: string;
  Path: string;
}
export interface BreadcrumbProps {
  fields?: {
    breadcrumb: BreadcrumbItem[];
  };
}

const Breadcrumb = ({ fields }: BreadcrumbProps) => {
  const [currentScrollX, setCurrentScrollX] = useState(0);
  if (!fields) {
    // No need to return missing datasource message for breadcrumb
    return <></>;
  }
  const { breadcrumb: crumbs } = fields;
  // Don't show breadcrumb when there is nothing to show
  if (crumbs.length === 0) {
    return <></>;
  }
  // beconnected is a little different then the others
  const isBeconnected = IsNmdpConnectSite();
  const maxScreenWidth = classnames(`max-w-screen-2xl`);
  const handleTouchStart = (event: TouchEvent) => {
    setCurrentScrollX(event.touches[0].clientX);
  };

  const handleTouchMove = (event: TouchEvent) => {
    event.preventDefault();

    const deltaX = currentScrollX - event.touches[0].clientX;
    const eventElement = event.currentTarget as HTMLElement;
    eventElement.scrollLeft += deltaX;
    setCurrentScrollX(event.touches[0].clientX);
  };
  return (
    <>
      {isBeconnected ? (
        <LayoutPageSectionShell theme="theme-white" padding="tiny">
          <nav aria-label="breadcrumbs" data-component="authorable/navigation/breadcrumb">
            <ol
              className={classnames(
                maxScreenWidth,
                'mx-auto',
                'flex',
                'relative',
                'whitespace-nowrap',
                'select-none',
                'overflow-x-auto',
                '-mb-2',
                'md:-mb-0'
              )}
              onTouchStart={() => handleTouchStart}
              onTouchMove={() => handleTouchMove}
            >
              {crumbs.map((item, index) => (
                <li key={item.Path} className={classnames('pb-2', 'md:pb-0')}>
                  {index < crumbs.length - 1 ? (
                    <>
                      <a
                        href={item.Path}
                        className={classnames(
                          'font-semibold',
                          'text-theme-btn-link-text',
                          'hover:text-theme-btn-link-text-hover',
                          'hover:underline'
                        )}
                        onClick={() => {
                          pageNavigationDataLayerPush(item.Name, menuLocation[6]);
                        }}
                      >
                        {item.Name}
                      </a>
                      <ArrowRight
                        aria-hidden="true"
                        className={classnames('inline-block', 'mx-3.5')}
                      />
                    </>
                  ) : (
                    <span aria-current="location">{item.Name}</span>
                  )}
                </li>
              ))}
            </ol>
          </nav>
        </LayoutPageSectionShell>
      ) : (
        <div className={classnames(maxScreenWidth, 'mx-auto', 'px-gutter-all')}>
          <nav aria-label="breadcrumbs" data-component="authorable/navigation/breadcrumb">
            <ol
              className={classnames(
                maxScreenWidth,
                'md:pt-2',
                'mx-auto',
                'flex',
                'relative',
                'whitespace-nowrap',
                'select-none',
                'overflow-x-auto'
              )}
              onTouchStart={() => handleTouchStart}
              onTouchMove={() => handleTouchMove}
            >
              {crumbs.map((item, index) => (
                <li
                  key={item.Path}
                  className={classnames(
                    'flex-row',
                    'py-3',
                    'rounded',
                    'first:pl-7',
                    'last:pr-7',
                    'md:first:pl-11',
                    'lg:first:pl-20',
                    'lg:last:pr-0'
                  )}
                >
                  <a
                    href={item.Path}
                    className={classnames(
                      'text-sm',
                      'font-regular',
                      'hover:font-medium',
                      'hover:text-theme-btn-link-text',
                      'text-theme-btn-link-text',
                      'hover:text-theme-btn-link-text-hover',
                      'underline'
                    )}
                    onClick={() => {
                      pageNavigationDataLayerPush(item.Name, menuLocation[6]);
                    }}
                  >
                    {item.Name}
                  </a>
                  {index < crumbs.length - 1 && (
                    <ArrowRight aria-hidden="true" className={classnames('inline-block', 'mx-1')} />
                  )}
                </li>
              ))}
            </ol>
          </nav>
        </div>
      )}
    </>
  );
};

export default Breadcrumb;
